import { defineMessages } from 'react-intl';

export default defineMessages({
  availabilityFallback: {
    id: 'ItemAvailability.availability',
    defaultMessage:
      'Available {isAvailable, select, true {today} other {in 2-5 Days}}'
  }
});
